var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"detalhamento-cirurgia"},[_c('li',[_vm._v("Sua cirurgia está "),_c('span',{staticClass:"status-agendado"},[_vm._v("AGENDADA")])]),_c('li',[_vm._v("\n      Veja em sua "),_c('a',{attrs:{"href":"/agenda"}},[_vm._v("agenda")]),_vm._v(" a data da internação e\n      cirurgia\n    ")])])])
}]

export { render, staticRenderFns }